var _style, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgWallet",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgWallet{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    className: "svgWallet svgBase svgHover svgSelect",
    d: "M18.4,9v-3c0-0.7-0.5-1.2-1.2-1.2h-2.1V3.6c0-0.7-0.5-1.2-1.2-1.2H2.6c-1,0-1.8,0.8-1.8,1.8 v12.2c0,0.7,0.5,1.2,1.2,1.2h15.3c0.7,0,1.2-0.5,1.2-1.2v-2.9c0.5,0,0.8-0.4,0.8-0.9V9.9C19.2,9.4,18.9,9.1,18.4,9z M17.3,9h-2.7 c-1.2,0-2.2,1-2.2,2.2c0,1.2,1,2.2,2.2,2.2h2.7v2.9c0,0,0,0.1-0.1,0.1l0,0H1.9c0,0-0.1,0-0.1-0.1V5.9C2.1,6,2.3,6,2.6,6h14.7 c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0V9z M18.1,10.1v2.2h-3.6c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1,1.1-1.1L18.1,10.1z M14,4.9H2.6 c-0.4,0-0.7-0.3-0.7-0.7c0-0.4,0.3-0.7,0.7-0.7c0,0,0,0,0,0h11.4c0,0,0.1,0,0.1,0.1V4.9z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.d9f9bf53.svg";
export { ForwardRef as ReactComponent };